import { render, staticRenderFns } from "./stockInformation.vue?vue&type=template&id=52974552&scoped=true"
import script from "./stockInformation.vue?vue&type=script&lang=js"
export * from "./stockInformation.vue?vue&type=script&lang=js"
import style0 from "./stockInformation.vue?vue&type=style&index=0&id=52974552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52974552",
  null
  
)

export default component.exports